<template>
    <el-dialog :title="title" :visible.sync="form_show" width="800px" :append-to-body="true" v-loading="form_loading" @close="onEditClose">
        <UserForm v-if="!form_loading && form_obj" mode="edit" @updated="onUpdated" @close="onEditClose" :user="form_obj" />
    </el-dialog>
</template>

<script>
import UserForm from "./UserForm.vue";

export default {
    name: "UserModal",
    components: {UserForm},
    data: () => ({
        form_show: false,
        form_obj: null,
        form_loading: false,
        id: null,
    }),
    mounted() {
        let self = this;
        this.$bus.$on('user:open-modal', id => {
            self.showEdit(id);
        })
    },
    beforeDestroy() {
        this.$bus.$off('user:open-modal');
    },
    computed: {
        title() {
            return "Редактирование пользователя";
        }
    },
    methods: {
        showEdit(id) {
            let self = this;
            this.id = id;
            this.form_show = true;
            this.form_loading = true;
            this.form_obj = null;

            axios.get('/api/users/' + id)
                .then(response => {
                    self.form_obj = response.data;
                    self.form_loading = false;
                })
        },
        onEditClose(){
            this.form_loading = false;
            this.form_show = false;
            this.form_obj = null;
            this.id = null;
        },
        onUpdated(user) {
            this.$bus.$emit('user:updated', user)
        },
    }
}
</script>

<style scoped>

</style>
